package com.partejar.app.feature.planos.data.remote

import com.partejar.app.feature.planos.data.Plano

class PlanosRemoteMapper {
    fun map(dto: PlanoDto) = Plano(
        id = dto.planoId,
        name = dto.nome,
        currentPrice = dto.valorAtual,
        active = dto.ativo,
        services = dto.servicos.sortedBy { it.ordemExibicao }.map { it.descricao }
    )
}
